<template>
  <div>
    <Breadcrumb routeName="ConsolidationServices" toName="添加运费模板" goPathName="配送服务"></Breadcrumb>
    <a-card :bordered="false">
      <div class="side">基本信息</div>
      <a-form-model
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        :label-col="currentFormLayout.labelCol"
        :wrapper-col="currentFormLayout.wrapperCol"
      >
        <a-form-model-item label="模板名称" prop="templateName">
          <a-input v-model="ruleForm.templateName" placeholder="请输入"></a-input>
        </a-form-model-item>
        <a-form-model-item label="模板类型" required>
          包邮模板
        </a-form-model-item>
        <a-form-model-item label="发货地区">
          <div class="color:rgba(51, 51, 51, 0.431372);font-size:13px">
            发货地与您的实际发货地不符，可能会导致物流投诉
          </div>
          <div>
            <a-cascader
              style="max-width: 400px;"
              :options="provinceList"
              @change="onCityChange"
              :value="cityList"
              placeholder="请选择省市区"
            />
          </div>
        </a-form-model-item>
        <div class="side">
          包邮区域
          <a-tooltip placement="right">
            <template slot="title">
              <span>当买家收货地址为包邮配送区域时，您将承担所有运费，买家无需承担运费。</span>
            </template>
            <img class="img" src="../../../assets/hint.png"/>
          </a-tooltip>
        </div>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
            全选
          </a-checkbox>
        </a-form-model-item>
        <a-form-model-item>
          <a-checkbox-group v-model="checkedList" @change="onFreeShippingChange">
            <div class="tr" style="white-space: nowrap;" v-for="(a, index) in plainOptions" :key="index">
              <span class="left-style">{{ a.groupName }}</span>
              <a-checkbox v-for="item in a.options" :key="item.value" :value="item.value"
                          :disabled="isPaymentOptions(item)">{{ item.label }}
              </a-checkbox>
            </div>
          </a-checkbox-group>
        </a-form-model-item>
        <div class="side">
          买家付邮费区域
          <a-tooltip placement="right">
            <template slot="title">
              <div class="side-width">当买家收货地址为买家付邮费区域时，买家需要按照您设定的运费规则承担运费。</div>
            </template>
            <img class="img" src="../../../assets/hint.png"/>
          </a-tooltip>
        </div>
        <a-form-model-item label="计费方式" required><span>按件计费</span></a-form-model-item>
        <a-form-model-item
          :wrapper-col="currentFormLayout.offsetCol"
          v-for="(contentSubmitDtoList, index) in ruleForm.contentSubmitDtoList"
          :key="contentSubmitDtoList.key"
        >
          <a-form-model-item
            style="display:inline-block"
            :prop="'contentSubmitDtoList.' + index + '.provinceId'"
            :rules="{
                required: true,
                message: '请选择',
                trigger: 'blur'
              }"
          >
            <a-select :allowClear="true" v-model="contentSubmitDtoList.provinceId" placeholder="请选择"
                      style="width: 120px;">
              <a-select-option v-for="paymentItem in getPaymentOptions(contentSubmitDtoList,index)"
                               :key="paymentItem.provinceId" :value="paymentItem.provinceId">
                {{ paymentItem.provinceName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item
            style="display:inline-block"
            :prop="'contentSubmitDtoList.' + index + '.number'"
            :rules="[
                {
                  required: true,
                  message: '请输入',
                  trigger: 'blur'
                }
              ]"
          >
            <a-input-number
              placeholder="请输入"
              :min="0"
              :formatter="limitNumber"
              :parser="limitNumber"
              style="margin-left: 20px; width: 80px;"
              v-model="contentSubmitDtoList.number"
            />
          </a-form-model-item>
          <span style="margin: 0 10px;">件内</span>
          <a-form-model-item
            style="display:inline-block"
            :prop="'contentSubmitDtoList.' + index + '.fee'"
            :rules="[
                {
                  required: true,
                  message: '请输入',
                  trigger: 'blur'
                }
              ]"
          >
            <a-input-number
              :min="0"
              :precision="2"
              placeholder="请输入"
              style=" width: 80px;"
              v-model="contentSubmitDtoList.fee"
            />
          </a-form-model-item>
          <span style="margin: 0 10px;">元</span>
          <span style="margin: 0 10px;">每增加</span>
          <a-form-model-item
            style="display:inline-block"
            :prop="'contentSubmitDtoList.' + index + '.addNumber'"
            :rules="{
                required: true,
                message: '请输入',
                trigger: 'blur'
              }"
          >
            <a-input-number
              :min="0"
              placeholder="请输入"
              :formatter="limitNumber"
              :parser="limitNumber"
              style=" width: 80px;"
              v-model="contentSubmitDtoList.addNumber"
            />
          </a-form-model-item>
          <span style="margin: 0 10px;">件，增加运费</span>
          <a-form-model-item
            style="display:inline-block"
            :prop="'contentSubmitDtoList.' + index + '.addFee'"
            :rules="{
                required: true,
                message: '请输入',
                trigger: 'blur'
              }"
          >
            <a-input-number
              placeholder="请输入"
              style=" width: 80px;"
              :min="0"
              :precision="2"
              v-model="contentSubmitDtoList.addFee"
            />
          </a-form-model-item>
          <span style="margin: 0 30px 0 10px;">元</span>
          <a-checkbox v-model="contentSubmitDtoList.freeFlag"></a-checkbox>
          <span style="margin: 0 10px;">满</span>
          <a-form-model-item
            style="display:inline-block"
            :prop="'contentSubmitDtoList.' + index + '.freeNumber'"
            :rules="{
                required: true,
                message: '请输入',
                trigger: 'blur'
              }"
          >
            <a-input-number
              placeholder="请输入"
              :min="0"
              :formatter="limitNumber"
              :parser="limitNumber"
              style="width: 80px; margin-left: 10px;"
              v-model="contentSubmitDtoList.freeNumber"
            />
          </a-form-model-item>
          <span style="margin: 0 10px;">件包邮</span>
          <a-icon
            v-if="ruleForm.contentSubmitDtoList.length > 0"
            class="dynamic-delete-button"
            type="minus-circle-o"
            @click="removecontentSubmitDtoList(contentSubmitDtoList)"
          />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="dashed" style="width: 100px;" @click="addcontentSubmitDtoList">
            <a-icon type="plus"/>
            添加
          </a-button
          >
        </a-form-model-item>
        <div class="side">
          疫情不发货区域
        </div>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <div class="forbid-area-box" v-if="ruleForm.forbidAreaSubmitList&&ruleForm.forbidAreaSubmitList.length">
            <div>{{ translateChinese(ruleForm.forbidAreaSubmitList) }}</div>
            <div>
              <a @click="editNoDistributionArea">编辑</a>
              <a-divider style="background: #797979" type="vertical"/>
              <a @click="deleteAreaList">删除</a>
            </div>
          </div>
          <a-button v-else type="dashed" @click="addNoDistributionArea">
            <a-icon type="plus"/>
            添加不配送区域
          </a-button
          >
        </a-form-model-item>
        <a-form-model-item :wrapper-col="currentFormLayout.offsetCol">
          <a-button type="primary" style="margin-right: 3%;" html-type="submit" :loading="submitLoading"
                    @click="submit">提交
          </a-button>
          <a-button @click="goBack">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
    <a-modal
      title='区域选择'
      :width='500'
      centered
      :visible='distributionAreaVisible'
      @cancel='handleCancel'
      @ok="handleSubmit"
    >
      <a-input-search style="margin-bottom: 8px" placeholder="查找省/市/区" @change="onChange"/>
      <div class="tree-box">
        <a-tree
          v-model="checkedKeys"
          :expanded-keys="expandedKeys"
          :auto-expand-parent="autoExpandParent"
          :tree-data="provinceList"
          @expand="onExpand"
          checkable
          :replace-fields="replaceFields"
          @check="checkArea"
        >
          <template slot="title" slot-scope="{ label }">
        <span v-if="label.indexOf(searchValue) > -1">
          {{ label.substr(0, label.indexOf(searchValue)) }}
          <span style="color: #f50">{{ searchValue }}</span>
          {{ label.substr(label.indexOf(searchValue) + searchValue.length) }}
        </span>
            <span v-else>{{ label }}</span>
          </template>
        </a-tree>
      </div>
    </a-modal>
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'

const getParentKey = (key, tree) => {
  let parentKey
  for (let i = 0; i < tree.length; i++) {
    const node = tree[i]
    if (node.children) {
      if (node.children.some(item => item.key === key)) {
        parentKey = node.key
      } else if (getParentKey(key, node.children)) {
        parentKey = getParentKey(key, node.children)
      }
    }
  }
  return parentKey
}
const dataList = []
const generateList = data => {
  for (let i = 0; i < data.length; i++) {
    const node = data[i]
    const key = node.key
    const label = node.label
    dataList.push({ key: key, title: label })
    if (node.children) {
      generateList(node.children)
    }
  }
}
export default {
  name: 'AddCarriageTemplate',
  components: {
    Breadcrumb
  },
  data() {
    return {
      currentFormLayout: {
        labelCol: {
          xxl: { span: 2 },
          xl: { span: 3 },
          lg: { span: 3 },
          sm: { span: 5 },
          md: { span: 8 },
          xs: { span: 10 }
        },
        wrapperCol: {
          xxl: { span: 8 }, //≥1600px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xl: { span: 8 }, //≥1200px 响应式栅格，可为栅格数或一个包含其他属性的对象
          lg: { span: 8 }, //≥992px 响应式栅格，可为栅格数或一个包含其他属性的对象
          sm: { span: 8 }, //≥768px 响应式栅格，可为栅格数或一个包含其他属性的对象
          md: { span: 3 }, //≥576px 响应式栅格，可为栅格数或一个包含其他属性的对象
          xs: { span: 3 } //xs	<576px 响应式栅格，可为栅格数或一个包含其他属性的对象
        },
        offsetCol: {
          xxl: { offset: 2 },
          xl: { offset: 3 },
          lg: { offset: 3 },
          sm: { offset: 5 },
          md: { offset: 8 },
          xs: { offset: 10 }
        }
      },
      cityList: [],
      provinceList: [],
      selected: [],
      id: this.$route.query.id,
      cloudMerchantId: this.$route.query.cloudMerchantId,
      cloudPlatformId: this.$route.query.cloudPlatformId,
      ruleForm: {
        freeArea: '',
        deliveryAreaId: '',
        deliveryCityId: '',
        deliveryProvinceId: '',
        templateType: 1,
        templateName: '',
        feeType: 1,
        contentSubmitDtoList: []
      },
      province: [],
      filterProvinceList: [],
      selectedList: [],
      checkedList: [],
      indeterminate: false,
      checkAll: false,
      plainOptions: [
        {
          checkedList: [],
          groupName: '华东:',
          options: [
            { label: '上海', value: '310000' },
            { label: '江苏', value: '320000' },
            { label: '浙江', value: '330000' },
            { label: '安徽', value: '340000' },
            { label: '江西', value: '360000' }
          ]
        },
        {
          checkedList: [],
          groupName: '华北:',
          options: [
            { label: '北京', value: '110000' },
            { label: '天津', value: '120000' },
            { label: '山西', value: '140000' },
            { label: '山东', value: '370000' },
            { label: '河北', value: '130000' },
            { label: '内蒙古', value: '150000' }
          ]
        },
        {
          checkedList: [],
          groupName: '华中:',
          options: [
            { label: '湖南', value: '430000' },
            { label: '湖北', value: '420000' },
            { label: '河南', value: '410000' }
          ]
        },
        {
          checkedList: [],
          groupName: '华南:',
          options: [
            { label: '广东', value: '440000' },
            { label: '广西', value: '450000' },
            { label: '福建', value: '350000' },
            { label: '海南', value: '460000' }
          ]
        },
        {
          checkedList: [],
          groupName: '东北:',
          options: [
            { label: '吉林', value: '220000' },
            { label: '辽宁', value: '210000' },
            { label: '黑龙江', value: '230000' }
          ]
        },
        {
          checkedList: [],
          groupName: '西北:',
          options: [
            { label: '陕西', value: '610000' },
            { label: '甘肃', value: '620000' },
            { label: '新疆', value: '650000' },
            { label: '宁夏', value: '640000' },
            { label: '青海', value: '630000' }
          ]
        },
        {
          checkedList: [],
          groupName: '西南:',
          options: [
            { label: '云南', value: '530000' },
            { label: '贵州', value: '520000' },
            { label: '西藏', value: '540000' },
            { label: '重庆', value: '500000' },
            { label: '四川', value: '510000' }
          ]
        },
        {
          checkedList: [],
          groupName: '港澳台:',
          options: [
            { label: '澳门', value: '820000' },
            { label: '香港', value: '810000' },
            { label: '台湾', value: '710000' }
          ]
        }
      ],
      rules: {
        templateName: [{ required: true, message: '请输入模板名称', trigger: 'blur' }]
      },
      submitFormData: '',
      distributionAreaVisible: false,
      autoExpandParent: true,
      expandedKeys: [],
      replaceFields: {
        children: 'children',
        title: 'label'
      },
      searchValue: '',
      checkedKeys: [],
      resultAreaList: [],
      submitLoading: false
    }
  },
  mounted() {
    this.getProvinceList()
    this.getProvince()
    this.detailList()
  },
  methods: {
    checkArea(checkedKeys, info) {
      let keysList = checkedKeys.concat(info.halfCheckedKeys)
      if (keysList && keysList.length) {
        this.selectedAreaList(keysList)
      }
    },
    selectedAreaList(keysList) {
      let provinceList = this.provinceList
      this.resultAreaList = this.sortOutChildren(provinceList, keysList)
    },
    getTileList(list) {
      let arr = []
      if (list && list.length) {
        list.forEach(item => {
          if (item.children && item.children.length) {
            arr.push(item)
            let subArr = this.getTileList(item.children)
            arr = arr.concat(subArr)
          }
        })
      }
      return arr
    },
    translateChinese(list) {
      let str = []
      if (this.provinceList && this.provinceList.length) {
        let checklist = this.getTileList(this.sortOutChildren(list, [], true))
        let allList = this.getTileList(this.sortOutChildren(this.provinceList, [], true))
        if (list && list.length) {
          list.forEach(item => {
            let itemStr = ''
            let checkObj = checklist.find(subItem => subItem.value == item.value)
            let allObj = allList.find(subItem => subItem.value == item.value)
            if (JSON.stringify(checkObj.children) == JSON.stringify(allObj.children)) {
              itemStr = `${item.label}`
            } else {
              itemStr = `${item.label}【${this.getChildrenStr(item.children, allList)}】`
            }
            str.push(itemStr)
          })
        }
      }
      return str.join('，')
    },
    getChildrenStr(list, allList) {
      let str = []
      if (list && list.length) {
        list.forEach(item => {
          let obj = allList.find(subItem => subItem.value == item.value)
          let itemStr = ''
          if (obj) {
            if (item.children.length == obj.children.length) {
              itemStr = `${item.label}`
            } else {
              itemStr = `${item.label}（${item.children.map(x => x.label).join('，')}）`
            }
            str.push(itemStr)
          }
        })
      }
      return str.join('，')
    },
    sortOutChildren(list, valueList, isAll = false) {
      let resultList = []
      if (list && list.length) {
        list.forEach(item => {
          if (valueList.some(ele => ele == item.value) || isAll) {
            let children = this.sortOutChildren(item.children, valueList, isAll)
            let obj = {
              label: item.label,
              value: item.value
            }
            if (children && children.length) {
              obj.children = children
            }
            resultList.push(obj)
          }
        })
      }
      return resultList
    },
    handleSubmit() {
      this.ruleForm.forbidAreaSubmitList = this.resultAreaList
      this.handleCancel()
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    onChange(e) {
      const value = e.target.value
      const expandedKeys = dataList
        .map(item => {
          if (item.title.indexOf(value) > -1) {
            return getParentKey(item.key, this.provinceList)
          }
          return null
        })
        .filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      })
    },
    handleCancel() {
      this.distributionAreaVisible = false
    },
    deleteAreaList() {
      this.ruleForm.forbidAreaSubmitList = []
      this.$forceUpdate()
    },
    editNoDistributionArea() {
      let forbidAreaSubmitList = this.ruleForm.forbidAreaSubmitList
      this.getSelectedKeys(forbidAreaSubmitList)
      this.distributionAreaVisible = true
    },
    getSelectedKeys(list) {
      if (list && list.length) {
        list.forEach(item => {
          if (item.children && item.children.length) {
            this.expandedKeys.push(item.value)
            this.getSelectedKeys(item.children)
          } else {
            this.checkedKeys.push(item.value)
          }
        })
      }
    },
    addNoDistributionArea() {
      this.checkedKeys = []
      this.distributionAreaVisible = true
    },
    //数据回显
    detailList() {
      if (this.id) {
        this.getHttpServices()
          .getCloudProService()
          .get('base/express/fee/detail', {
            templateId: this.id,
            merchantId: this.cloudMerchantId,
            platformId: this.cloudPlatformId
          })
          .then(res => {
            if (res.freeArea) {
              this.checkedList = res.freeArea.split(',')
            }
            let newArray = res.contentSubmitDtoList
            if (newArray && newArray.length > 0) {
              newArray.forEach(item => {
                if (item.freeFlag == 1) {
                  item.freeFlag = true
                } else {
                  item.freeFlag = false
                }
              })
            }
            this.ruleForm.contentSubmitDtoList = newArray
            this.ruleForm.templateName = res.templateName
            this.ruleForm.deliveryAreaId = res.deliveryAreaId
            this.ruleForm.deliveryCityId = res.deliveryCityId
            this.ruleForm.deliveryProvinceId = res.deliveryProvinceId
            this.ruleForm.forbidAreaSubmitList = res.forbidAreaSubmitList && res.forbidAreaSubmitList.length ? res.forbidAreaSubmitList : []
            if (res.freeArea) {
              this.indeterminate = true
            }
            if (res.deliveryProvinceId || res.deliveryCityId || res.deliveryAreaId) {
              this.cityList = [
                res.deliveryProvinceId,
                res.deliveryCityId,
                res.deliveryAreaId
              ]
            }
          })
          .catch(err => {
            this.$message.error(err.msg)
          })
      }
    },
    //提交
    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.syb()
        }
      })
    },
    syb() {
      let flag = true
      this.getLogUtils().logWithTag('contentSubmitDtoList', this.ruleForm.contentSubmitDtoList)
      this.ruleForm.contentSubmitDtoList.forEach(item => {
        if (item.freeFlag == true) {
          if (item.number >= item.freeNumber) {
            return flag = false
          }
        }
      })
      if (!flag) {
        this.$message.error('包邮件数请大于寄件件数')
        return
      }
      this.ruleForm.freeArea = this.checkedList.join(',')
      this.ruleForm.id = this.id
      this.ruleForm.merchantId = this.cloudMerchantId,
        this.ruleForm.platformId = this.cloudPlatformId
      this.submitFormData = JSON.parse(JSON.stringify(this.ruleForm))
      this.submitLoading = true
      this.getHttpServices()
        .getCloudProService()
        .post('base/express/fee/submit', this.submitFormData)
        .then(res => {
          this.$message.success('提交成功')
          this.goBack()
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
        .finally(() => {
          setTimeout(() => this.submitLoading = false, 500)
        })
    },
    //返回上一路由
    goBack() {
      this.$router.go(-1)
    },
    onCityChange(value) {
      if (value && value.length) {
        this.ruleForm.deliveryProvinceId = value[0]
        this.ruleForm.deliveryCityId = value[1]
        this.ruleForm.deliveryAreaId = value[2]
        this.cityList = [value[0], value[1], value[2]]
        this.getLogUtils().logWithTag('cityList', this.cityList)
      } else {
        this.cityList = []
        this.getLogUtils().logWithTag('cityList', this.cityList)
      }
    },
    //只获取省
    getProvince() {
      this.getHttpServices()
        .getBaseService()
        .post('province/getProvinceList')
        .then(res => {
          this.province = res
          this.filterProvinceList = res
        })
        .catch(err => {
          this.$message.error(err.msg)
        })
    },
    removecontentSubmitDtoList(item) {
      let index = this.ruleForm.contentSubmitDtoList.indexOf(item)
      if (index !== -1) {
        this.ruleForm.contentSubmitDtoList.splice(index, 1)
      }
    },
    addcontentSubmitDtoList() {
      if (this.checkAll) {
        this.$message.error('已选全国包邮')
        return false
      }
      this.ruleForm.contentSubmitDtoList.push({})
    },
    //获取可选的付费地区
    getPaymentOptions(item, index) {
      let filterPayment = this.ruleForm.contentSubmitDtoList.filter((oItem, oIndex) => oIndex !== index)
      let filterList = this.province.filter(item => this.checkedList.findIndex(i => i == item.provinceId) < 0)
      return filterList.filter(pItem => filterPayment.findIndex(payItem => payItem.provinceId == pItem.provinceId) < 0)
    },
    //判断是否是付费的选中
    isPaymentOptions(item) {
      if (this.ruleForm.contentSubmitDtoList.length > 0) {
        return this.ruleForm.contentSubmitDtoList.findIndex(selectedItem => selectedItem.provinceId == item.value) >= 0
      }
      return false
    },
    //包邮选择改变事件
    onFreeShippingChange(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.getChecked().length
      this.checkAll = checkedList.length === this.getChecked().length
    },
    filterProvince() {
      let provinceList = this.province
      let filterList = provinceList.filter(item => this.checkedList.findIndex(i => i == item.provinceId) < 0)
      this.filterProvinceList = filterList
    },
    getChecked() {
      const list = []
      for (let i = 0, len = this.plainOptions.length; i < len; i++) {
        list.push(...this.plainOptions[i].options)
      }
      return list
    },
    onCheckAllChange(e) {
      let selectedArr = []
      for (let index in this.getChecked()) {
        const selectObj = this.getChecked()[index]
        selectedArr.push(selectObj.value)
      }
      this.checkedList = e.target.checked ? selectedArr : []
      this.indeterminate = false
      this.checkAll = e.target.checked
      if (this.checkAll) {
        this.ruleForm.contentSubmitDtoList = []
      }
      this.filterProvince()
    },
    //获取省市区
    getProvinceList() {
      this.getHttpServices()
        .getBaseService()
        .get('province/getProvinceCityCounty')
        .then(res => {
          if (res && res.length) {
            this.provinceList = this.changeChildren(res)
            generateList(this.provinceList)
          }
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    changeChildren(list) {
      list.forEach(item => {
        item.scopedSlots = { title: 'title' }
        item.key = item.value
        if (item.children && item.children.length) {
          item.children = this.changeChildren(item.children)
        }
      })
      return list
    },
    limitNumber(value) {
      if (typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(/\./g, '') : 0
      } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(/\./g, '') : 0
      } else {
        return 0
      }
    }
  }
}
</script>
<style lang="less" scoped>

.side {
  padding-left: 10px;
  line-height: 18px;
  font-size: 16px;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 10px;
  border-left: 1px solid cornflowerblue;
}

.img {
  width: 16px;
}

.item {
  width: 500px !important;
}

.tr {
  font-size: 14px;
  display: flex;
  margin: 20px 0;
}

.left-style {
  width: 105px;
  margin-right: 10px;
  text-align: right;
}

.tree-box {
  max-height: 600px;
  overflow-y: auto;
}

.forbid-area-box {
  background: #F5F5F6;
  padding: 10px 20px;
  border-radius: 8px;
}
</style>
<style lang="less">
body {
  .ant-tooltip-inner {
    width: 520px !important;
  }
}
</style>
